import { createContext, useContext } from "react";

export const EndedSelectionContext = createContext({
  selectedIds: [],
  toggleSelection: () => {},
  clearSelection: () => {},
});

export default function useEndedSelection() {
  return useContext(EndedSelectionContext);
}
